import useComponentPadding from '@hero/ui-kit/hooks/useComponentPadding';
const useEnterpriseMemberListStyles = () => {
    const innerWrapPadding = useComponentPadding({ paddingVertical: 'regular' });
    const tableWrapStyles = {
        overflowX: 'auto'
    };
    return { innerWrapPadding, tableWrapStyles };
};
export default useEnterpriseMemberListStyles;
